import React from "react";
import ClerkIncrementsButtonsGrid from "./ClerkIncrementsButtonsGrid";
import ClerkRoundStopButtonsGroup from "./ClerkRoundStopButtonsGroup";
import ClerkBiddingEditableNumericDisplayRowCmp from "./ClerkBiddingEditableNumericDisplayRowCmp";
import {TaggedLogger} from "@nextlot/core/utilities";
import {AuctionsManager, DataStore} from "@nextlot/core/webcast";
import {useAppSelector} from "@nextlot/core/webcast/hooks";
import {ClerkPlaceFloorAndOnlineBidButtonsStack} from "./ClerkPlaceFloorAndOnlineBidButtonsStack";


const _logger = TaggedLogger.get('ClerkRoundStartUpdateOpeningBidCmp');



export default function ClerkRoundStartUpdateOpeningBidCmp() {

    const currentRoundId = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.roundId);
    const askingBidValue = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.askingBidValue);

    const handleOnClick_IncrementButton = (centsValue:number) => {
        const newCentsValue = Math.max(1, askingBidValue + centsValue); // avoid 0 or negative values
        AuctionsManager.currentWebcastAuctionHandler.controller.sendAskingBidUpdate(currentRoundId, newCentsValue);
    };

    const handleValidateAndSubmitNewValue_AskBid = (valueCents:number):string|null => {
        if (valueCents === askingBidValue) {
            return 'Must be different then current asking bid'
        }

        AuctionsManager.currentWebcastAuctionHandler.controller.sendAskingBidUpdate(currentRoundId, valueCents);

        // if validation ok, return null
        return null;
    };



    return (
        <div className="w-100 pb-3 d-flex flex-column">

            <ClerkRoundStopButtonsGroup
                currentRoundId={currentRoundId}
            />


            <div className="pt-2 ps-2 pb-5 d-flex justify-content-between align-items-start">

                <div className="clerk-bidding-values-container">

                    <ClerkBiddingEditableNumericDisplayRowCmp
                        label={'Asking:'}
                        valueCents={askingBidValue}
                        validateAndSubmitNewValueCents={handleValidateAndSubmitNewValue_AskBid}
                        componentClassName={'bidding-values__row-asking-bid-value'}
                    />

                </div>

                <ClerkPlaceFloorAndOnlineBidButtonsStack />
            </div>



            <ClerkIncrementsButtonsGrid
                onButtonClick={handleOnClick_IncrementButton}
                valuesList={DataStore.config.default_clerk_increments}
                valuesSign={-1}
            />

            <br />

            <ClerkIncrementsButtonsGrid
                onButtonClick={handleOnClick_IncrementButton}
                valuesList={DataStore.config.default_clerk_increments}
                valuesSign={1}
            />

        </div>
    )
}
